import { Box } from '@mui/material';

import Header from '../components/header/Header';

export default function Page({ children }: { children: React.ReactNode }) {
  return (
    <Box
      display='flex'
      flexDirection='column'
      height='100vh'
      width='100vw'
      sx={{ overflowX: 'hidden' }}
    >
      <Header />
      {children}
    </Box>
  );
}
